import { ShieldExclamationIcon } from "@heroicons/react/24/outline";
import Modal from "./Modal";

export default function DisclaimerModal({ isOpen, setIsOpen, content }) {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="max-w-xl" closeOnOutsideClick={false}>
      <div className="bg-white px-5 pt-6 pb-5 sm:px-8 sm:pt-8 sm:pb-6 rounded-t-lg">
        <div className="flex items-center gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-50 ring-1 ring-amber-200/80">
            <ShieldExclamationIcon className="h-6 w-6 text-amber-600" aria-hidden="true" />
          </div>
          <h3 className="text-lg font-semibold tracking-tight text-gray-900">
            Disclaimer
          </h3>
        </div>
        <div className="mt-5 rounded-lg border border-gray-100 bg-gray-50/60 px-4 py-4">
          <p className="text-sm leading-relaxed text-gray-600 whitespace-pre-line">{content}</p>
        </div>
      </div>
      <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-lg">
        <button
          onClick={() => setIsOpen(false)}
          type="button"
          className="mt-3 inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:mt-0 sm:w-auto"
        >
          I Acknowledge
        </button>
      </div>
    </Modal>
  );
}
